'use client';
var classes = {"root":"m-559cce2d","content":"m-b912df4e","control":"m-b9131032"};

export default classes;
//# sourceMappingURL=Spoiler.module.mjs.map
